export default __webpack_public_path__ + "8bf000da8507b1fc8579feb64fbf4d00.png";